import React, { useState } from "react";
import { QueryClient, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { postStores } from "../../../MyApi/stores";
import HeaderBar from "../../../Components/UI/headerbar";
import NavTabsBar from "../../../Components/UI/navtabsbar";
import OwnerInfoForm from "../../../Components/stores/storesStore/ownerInfoForm";
import StoreInfoForm from "../../../Components/stores/storesStore/StoreInfoForm";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const StoresStorePage = () => {
  const tabs = [
    { key: "store_info", label: "معلومات المتجر", permission: "create_store" },
  ];
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("store_info");

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    phone_code: "",

    is_owner: 1,
    is_active: 1,
  });
  const [address, setAddress] = useState({
    country_id: null,
    city_id: null,
    governorate_id: null,
    zone_id: null,
    latitude: null,
    longitude: null,
    zones_to_cover: [],
  });

  const queryClient = useQueryClient();
  /* ====== ERRORS ====== */
  const [errorMessage, setErrorMessage] = useState({});
  const [locationError, setLocationError] = useState(null);
  const [Errors, setErrors] = useState([]);

  const [searchParams] = useSearchParams();
  const store_id = searchParams.get("store_id");
  const store_name = searchParams.get("store_name");
  const store_type = searchParams.get("type");

  const mutation = useMutation({
    mutationKey: ["postStore"],
    mutationFn: (postData) => postStores(postData),
    onSuccess: (data) => {
      toast.success(data.message);
      const from = location.state?.from || `${process.env.PUBLIC_URL}/stores`;
      navigate(from, { replace: true });
      queryClient.invalidateQueries("stores");
    },
    onError: (error) => {
      const statusError = error?.response?.status;
      const errorData = error?.response?.data?.data;

      toast.error("تحقق من البيانات المطلوبة");
    },
  });
  /* ====== TAB CONTROL ====== */

  const onTabChange = (tabKey) => {
    if (tabKey === "store_info") {
      const isVendorEmpty =
        !formData ||
        !formData.first_name ||
        !formData.last_name ||
        !formData.email ||
        !formData.phone ||
        !formData.phone_code ||
        formData.password;
    }

    setActiveTab(tabKey);
  };

  const handleAddVendor = () => {
    setActiveTab("store_info");
  };

  const handleAddStore = (storeData, working_days) => {
    const dataToSend = new FormData();

    if (address.latitude === null || address.longitude === null) {
      console.log("validate");
      setLocationError((prev) => ({
        ...prev,
        location: "يرجي إدخال موقع علي الخريطة",
      }));
    }

    // Add owner_id if selected
    if (storeData.owner_id) {
      dataToSend.append("owner_id", storeData.owner_id);
    }

    if (storeData.branch_type !== "branch") {
      Object.keys(formData).forEach((key) => {
        dataToSend.append(`vendor[${key}]`, formData[key]);
      });
    }

    Object.keys(storeData).forEach((key) => {
      const value = storeData[key];

      dataToSend.append(`store[${key}]`, value);
    });
    Object.keys(address).forEach((key) => {
      const value = address[key];
      dataToSend.append(`address[${key}]`, value);
    });
    address.zones_to_cover.forEach((zones, i) => {
      dataToSend.append(`zones_to_cover[${i}]`, zones);
    });

    working_days.forEach((work, i) => {
      dataToSend.append(`working_days[${i}][day_of_week]`, work.day_of_week);
      dataToSend.append(`working_days[${i}][open_time]`, work.open_time);
      dataToSend.append(`working_days[${i}][close_time]`, work.close_time);
    });
    mutation.mutate(dataToSend);
  };

  return (
    <div>
      <HeaderBar
        title="إضافة متجر"
        content="أنشئ متجرًا جديدًا بمعلومات المالك."
        isBack={true}
      />

      <div className="container">
        <div className="card rounded-4">
          <div className="card-body">
            <NavTabsBar
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={onTabChange}
            />

            {/* <OwnerInfoForm
              errorMessage={errorMessage}
              onSave={handleAddVendor}
              isShowComponent={activeTab === "owner_info"}
              setErrors={setErrors}
              Errors={Errors}
              formData={formData}
              setFormData={setFormData}
            /> */}

            <StoreInfoForm
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              locationError={locationError}
              setLocationError={setLocationError}
              onSave={handleAddStore}
              isLoadingMutate={mutation.isLoading}
              setAddress={setAddress}
              address={address}
              isShowComponent={activeTab === "store_info"}
              store_id={store_id}
              store_name={store_name}
              store_type={store_type}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoresStorePage;
